import { forwardRef, type HTMLAttributes } from 'react';
import InfoIcon from '@assets/img/icons/info.svg?react';
import cn from 'classnames';

import css from './styles.module.scss';

const Info = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  (props, ref) => {
    return (
      <div ref={ref} {...props} className={cn(css.info, props.className)}>
        <InfoIcon className="w-5 h-5 shrink-0" />
      </div>
    );
  },
);

export { Info };
